// Serialize native fullscreen transitions: double-click must not start two overlapping requests.
const pending=new WeakSet<Element>();
let fallback:{tile:HTMLElement;close:()=>void}|null=null;
function openFallback(tile:HTMLElement){
 fallback?.close();
 const marker=document.createComment('stream-fullscreen'),parent=tile.parentNode;
 if(!parent)return;
 parent.insertBefore(marker,tile);
 const host=document.createElement('div');host.className='voice-v2 stream-fullscreen-host';host.setAttribute('role','dialog');host.setAttribute('aria-modal','true');host.setAttribute('aria-label','Fullscreen stream');
 const button=document.createElement('button');button.type='button';button.className='stream-fullscreen-close';button.setAttribute('aria-label','Close fullscreen');button.textContent='×';
 const previous=document.activeElement as HTMLElement|null,overflow=document.body.style.overflow;
 const close=()=>{observer.disconnect();window.removeEventListener('keydown',escape);window.removeEventListener('pagehide',close);window.removeEventListener('popstate',close);if(marker.parentNode){if(tile.isConnected)marker.replaceWith(tile);else marker.remove();}host.remove();document.body.style.overflow=overflow;fallback=null;previous?.focus();};
 const escape=(e:KeyboardEvent)=>{if(e.key==='Escape'){e.stopPropagation();close()}};
 const observer=new MutationObserver(()=>{if(!marker.isConnected||!tile.isConnected)close()});
 host.append(tile,button);document.body.append(host);document.body.style.overflow='hidden';button.onclick=close;
 observer.observe(document.body,{childList:true,subtree:true});window.addEventListener('keydown',escape);window.addEventListener('pagehide',close);window.addEventListener('popstate',close);fallback={tile,close};button.focus();
}
export async function toggleStreamFullscreen(tile:HTMLElement){
 if(pending.has(tile)||!tile.isConnected)return;
 if(fallback?.tile===tile){fallback.close();return}
 pending.add(tile);
 try{
  if(fallback?.tile===tile){fallback.close();return}
  if(document.fullscreenElement===tile){await document.exitFullscreen();return}
  if(document.fullscreenElement)await document.exitFullscreen();
  if(typeof tile.requestFullscreen==='function'){try{await tile.requestFullscreen();return}catch{/* Safari can expose this method without supporting arbitrary elements. */}}
  const video=tile.querySelector?.('video') as (HTMLVideoElement&{webkitEnterFullscreen?:()=>void;webkitSupportsFullscreen?:boolean})|null;
  if(video?.webkitEnterFullscreen&&video.webkitSupportsFullscreen!==false){try{video.webkitEnterFullscreen();return}catch{/* Live streams can reject native video fullscreen. */}}
  if(tile.isConnected)openFallback(tile);
 }
 catch{if(tile.isConnected)openFallback(tile);}
 finally{pending.delete(tile);}
}
